<shared-ui-datetime-range-picker #rangePicker (dateFilter)="onInnerDateFilter($event)">
  <ng-template #footer>
    <div class="ranges">
      <ul class="d-flex justify-content-between">
        <li *ngFor="let term of orderedSearchRangeTerms" [class.active]="selectedSearchRangeTerm === term" (click)="onTermClicked(term)">
          {{ term }}
        </li>
      </ul>
    </div>
  </ng-template>
</shared-ui-datetime-range-picker>
